import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import { sitemap } from 'app/shared/util/url-utils';
import { useGetCurrentUserProfileQuery } from 'app/store/reducers/api/config-manager-cloud-services/store/user-profiles';
import { UserRead } from 'app/store/reducers/api/config-manager-cloud-services/store/types';
import { LoadingSkeleton } from 'app/modules/loading-lib/component/LoadingSkeleton';
import { usePermission } from '../hooks/usePermission';

interface RequirePermissionProps {
  permission: string;
  redirectTo?: string;
  children?: React.ReactNode;
}

/** Route-level permission guard (the redirecting counterpart to <Restricted/>). */
export const RequirePermission: React.FC<RequirePermissionProps> = ({
  permission,
  redirectTo = sitemap.home,
  children,
}) => {
  const { data: profile = {} as UserRead, isLoading } = useGetCurrentUserProfileQuery();
  const allowed = usePermission(permission);

  if (isLoading || !profile.currentAccount) {
    return <LoadingSkeleton />;
  }
  if (!allowed) {
    return <Navigate replace to={redirectTo} />;
  }
  return <>{children ?? <Outlet />}</>;
};

export default RequirePermission;
